<template>
  <div
    style="display:grid;grid-template-rows: repeat(5, 1fr);grid-gap:2rem;padding-left: 4rem;padding-right: 4rem;"
  >
    <div>
      <div style="display:grid;grid-template-columns: repeat(2, 1fr);grid-gap:3rem">
        <b-form-group label="NDC 11*">
          <b-form-input
            v-model="copyNDCsFormData.ndC11"
            :state="$v.copyNDCsFormData.ndC11.$error
            ? $v.copyNDCsFormData.ndC11.isValidNDC11
            : null"
            :disabled="isAddNDCsForm ? false: true"
          />
          <b-form-invalid-feedback v-if="!hasNDC11Valid">{{ndC11InValidMessage}}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="NDC Package Code">
          <b-form-input
            v-model="copyNDCsFormData.ndcPackageCode"
            :state="$v.copyNDCsFormData.ndcPackageCode.$error
            ? $v.copyNDCsFormData.ndcPackageCode.isValidNDCPackageCode
            : null"
          />
        </b-form-group>
      </div>
    </div>
    <div>
      <div style="display:grid;grid-template-columns: repeat(2, 1fr);grid-gap:3rem">
        <b-form-group label="NDC 9">
          <b-form-input
            v-model="copyNDCsFormData.ndC9"
            :state="$v.copyNDCsFormData.ndC9.$error
            ? $v.copyNDCsFormData.ndC9.isValidNDC9
            : null"
          />
        </b-form-group>
        <b-form-group label="Product NDC">
          <b-form-input
            v-model="copyNDCsFormData.productNDC"
            :state="$v.copyNDCsFormData.productNDC.$error
          ? $v.copyNDCsFormData.productNDC.isValidProductNDC
          : null"
          />
        </b-form-group>
      </div>
    </div>
    <div style="display:grid">
      <b-form-group label="NDC Description*">
        <b-form-input
          v-model="copyNDCsFormData.ndcDescription"
          :state="$v.copyNDCsFormData.ndcDescription.$error
          ? !$v.copyNDCsFormData.ndcDescription.$error
          : null"
        />
      </b-form-group>
    </div>
    <div style="display:grid">
      <b-form-group label="Dosage Form Name">
        <b-form-input v-model="copyNDCsFormData.dosageFormName" />
      </b-form-group>
    </div>
  </div>
</template>



<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'KnownNDCsAddEditForm',
  props: ['isAddNDCsForm', 'knownNDCsDetail'],
  data() {
    return {
      ndC11InValidMessage: '',
      hasNDC11Valid: true
    };
  },
  computed: {
    ...mapState('brandName', ['copyNDCsFormData', 'isNDC11AlreadyExists'])
  },
  methods: {
    ...mapActions('brandName', [
      'setNDCsFormDataInState',
      'checkExistenceOfReferenceDrugNDC11'
    ]),
    regexToValidateNDC11(val) {
      return /^\d{11}$/.test(val);
    },
    async isValidateNDC11(ndC11) {
      if (!this.regexToValidateNDC11(ndC11)) {
        this.ndC11InValidMessage = '';
        return false;
      }

      await this.checkExistenceOfReferenceDrugNDC11(ndC11);

      if (!this.isNDC11AlreadyExists) {
        this.hasNDC11Valid = true;
        this.ndC11InValidMessage = '';
        return true;
      } else {
        this.hasNDC11Valid = false;
        this.ndC11InValidMessage = 'NDC11 already exists';
        return false;
      }
    }
  },
  validations() {
    return {
      copyNDCsFormData: {
        ndC11: {
          isValidNDC11(val) {
            return this.isAddNDCsForm ? this.isValidateNDC11(val) : true;
          }
        },
        ndcPackageCode: {
          isValidNDCPackageCode(val) {
            return _.isEmpty(val) ? true : /^(\d+)+((-(\d+)+)?)+$/.test(val);
          }
        },
        ndC9: {
          isValidNDC9(val) {
            return _.isEmpty(val) ? true : /^\d{9}$/.test(val);
          }
        },
        ndcDescription: { required },
        productNDC: {
          isValidProductNDC(val) {
            return _.isEmpty(val) ? true : /^(\d+)+((-(\d+)+)?)+$/.test(val);
          }
        }
      }
    };
  },
  created() {
    this.setNDCsFormDataInState(this.knownNDCsDetail);
  }
};
</script>
